// Canonical device-type list for the alarm register — SINGLE SOURCE OF TRUTH
// (SEC-216). Every device-type dropdown/filter imports from here, and
// automatic device creation from orders resolves catalog product types (never
// the editable product name) to these strings and sends the resolved value to
// the server.
// The alarm stack branches on these exact strings (Alarm.type) — new device
// models are added HERE only.

export const PERSONAL_ALARM_TYPES = [
  "SRT306", "SRT306i", "SRT306 G2", "SRT326", "SRT330", "SRT334",
  "SRT405", "SRT405i", "SRT406", "SRT406i", "SRT430", "SRT278", "SRT341",
  "TWIG Neo", "TWIG Neo SRD", "TWIG Neo MD", "TWIG Neo SRD MD",
  "TWIG One", "TWIG One SRD", "TWIG One EX", "TWIG Button", "TWIG Eon",
  "TWIG Beacon", "TWIG Beacon EX",
  "EMERIT WG100", "EMERIT WG200", "EMERIT WG200-G", "EMERIT e-B10",
  "TELTONIKA FMC003", "4G Box", "Anchor Beacon",
  "Avigilon Alta Compact Dome 5MP", "SecurDesktop", "SecurApp",
];

export const AJAX_DEVICE_TYPES = [
  "AJAX Hub 2 Plus", "AJAX Hub 2 (4G)", "AJAX Hub 2 (2G)", "AJAX Hub (4G)", "AJAX Hub (2G)",
  "AJAX DoorProtect Plus", "AJAX DoorProtect", "AJAX ReX 2", "AJAX ReX",
  "AJAX MotionProtect Plus", "AJAX MotionProtect", "AJAX CombiProtect",
  "AJAX DomeCam", "AJAX MotionCam", "AJAX MotionCam (PhOD)",
  "AJAX MotionProtect Curtain", "AJAX MotionCam Outdoor", "AJAX MotionCam Outdoor (PhOD)",
  "AJAX MotionProtect Outdoor", "AJAX DualCurtain Outdoor",
  "AJAX KeyPad TouchScreen", "AJAX KeyPad Plus", "AJAX KeyPad",
  "AJAX Button", "AJAX DoubleButton", "AJAX SpaceControl",
  "AJAX Transmitter", "AJAX Transmitter Jeweller", "AJAX FireProtect 2",
  "AJAX DoorBell", "AJAX Superior StreetSiren Plus", "AJAX Superior HomeSiren Jeweller",
];

export const DEVICE_TYPES = [...PERSONAL_ALARM_TYPES, ...AJAX_DEVICE_TYPES];
const DEVICE_TYPE_SET = new Set(DEVICE_TYPES);

// Catalog product types are generated from hand-written names and rarely match
// the register's device-type strings exactly ("ajax_hub2_plus", "hub_2_plus",
// "rex_2_jeweller", "(phod)" vs "(PhOD)"). Matching is done on a normalized
// form: lowercase, alphanumerics only.
function normalizeName(name) {
  return String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

const NORMALIZED_DEVICE_TYPES = new Map(DEVICE_TYPES.map((t) => [normalizeName(t), t]));

/**
 * Map a catalog product type to the canonical device-type string the alarm
 * register uses, or null when there is no safe match. For ajax-category
 * products the "AJAX" prefix and the "Jeweller" suffix are tolerated, since
 * the catalog is inconsistent about both.
 */
export function resolveDeviceType(name, category) {
  if (!name) return null;
  if (DEVICE_TYPE_SET.has(name)) return name;

  const normalized = normalizeName(name);
  if (NORMALIZED_DEVICE_TYPES.has(normalized)) return NORMALIZED_DEVICE_TYPES.get(normalized);

  if (category === "ajax") {
    const candidates = [];
    if (!normalized.startsWith("ajax")) candidates.push(`ajax${normalized}`);
    const withoutJeweller = normalized.replace(/jeweller$/, "");
    if (withoutJeweller !== normalized) {
      candidates.push(withoutJeweller);
      candidates.push(withoutJeweller.startsWith("ajax") ? withoutJeweller : `ajax${withoutJeweller}`);
    }
    for (const candidate of candidates) {
      if (NORMALIZED_DEVICE_TYPES.has(candidate)) return NORMALIZED_DEVICE_TYPES.get(candidate);
    }
  }

  return null;
}
